export enum UI_STATES {
  LOGGED_OUT = 1,
  LOGGED_IN = 2,
  LOGGING_IN = 3,
  DEVICE_SELECTION = 4
}
